export default __webpack_public_path__ + "static/media/expiryDate2.ebc85ca5.jpg";